import {FormControl, FormHelperText, MenuItem, Select, SelectProps, makeStyles} from '@material-ui/core';
import {ExpandMore} from '@material-ui/icons';
import classNames from 'classnames';
import {QuoteFormDropdownOption} from 'Quoting/models/DTOs/QuoteForm';
import React from 'react';
import {InputProps} from '../../models/FormInputs';
import {useDropdownOptions} from '../hooks/useDropdownOptions';
import {useEnabledSelectStyles} from './styles';

type QuoteDropdownProps = SelectProps &
  InputProps & {
    coverageCode?: string;
    optionsFilter?: Array<QuoteFormDropdownOption['value']>;
    dropdownVariant: DropdownVariant;
    searchKey: string;
    helperText?: string;
  };

const useDropdownStyles = makeStyles(() => ({
  quoteDropdown: ({isDisabled}: {isDisabled?: boolean}) => ({
    borderRadius: 0,
    marginTop: '0.5rem',
    marginBottom: '0.25rem',
    backgroundColor: isDisabled ? '#E8E8E8' : 'transparent',
    color: isDisabled ? '#474747' : '#000',
    '& > div': {
      paddingTop: '0.656rem',
      paddingBottom: '0.656rem',
    },
    borderColor: '#0075D1',
  }),
}));

export type DropdownVariant = 'Lookup' | 'AttributeValue';

export const QuoteDropdownV2 = (props: QuoteDropdownProps) => {
  const {
    dropdownVariant = 'AttributeValue',
    inputFieldProps,
    className,
    searchKey,
    error,
    label,
    value,
    helperText,
    coverageCode,
    ...otherProps
  } = props;

  const classes = useDropdownStyles({isDisabled: props.disabled});
  const options = useDropdownOptions(dropdownVariant, searchKey, coverageCode);

  const enabledSelectInputStyles = useEnabledSelectStyles();

  const renderValue = getRenderValue(options, value);

  return (
    <FormControl required error={error} fullWidth>
      <Select
        inputProps={{style: inputFieldProps?.style, ['data-testid']: props.id}}
        className={classNames(className, classes.quoteDropdown, {
          [enabledSelectInputStyles.input]: otherProps.disabled === false,
        })}
        variant="outlined"
        IconComponent={ExpandMore}
        style={{
          borderRadius: 0,
          backgroundColor: props.disabled ? '#E8E8E8' : 'transparent',
          color: props.disabled ? '#474747' : '#000',
        }}
        title={(value as string) ?? ''}
        value={value ?? ''}
        renderValue={renderValue}
        {...otherProps}
      >
        {options.map(({label, value}) => (
          <MenuItem value={value} key={`dropdown-${label}-${value}`}>
            {label}
          </MenuItem>
        ))}
      </Select>
      <FormHelperText>{helperText ?? ''}</FormHelperText>
    </FormControl>
  );
};

const getRenderValue = (options: QuoteFormDropdownOption[], value: any) =>
  options.some(opt => opt.value === value)
    ? undefined
    : val => {
        const valueToRender = options.find(opt => opt.value === String(val));
        return valueToRender?.label ?? val;
      };
